import * as con from "../../GlobalConstants";
import GlobalViewComponent from './GlobalViewComponent';
import MarketChart from '../charts/MarketChart';
import { RefMarketValueHook } from '../hooks/MarketValuesHook';

function MarketViewGlobalViewComponent({ alerts }) {
  const marketValues = RefMarketValueHook(con.HISTORIC_DOLLAR_INFO);

  return (
    <GlobalViewComponent 
      pageLink={con.PAGE_MARKETS_TECHNICAL_ANALYSIS}
      title={
        <div style={{ marginBottom: '-10px', fontSize: 'inherit', fontWeight: 'inherit' }}>
          MERCADO
        </div>
      } 
    >
      <div style={{ height: "35vh", width: "100%" }}>
        <MarketChart data={marketValues} alerts={alerts} />
      </div>

    </GlobalViewComponent>
  );
}

export default MarketViewGlobalViewComponent;
